module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zDszCa/tc-custom/9781399097574.jpg?1713496986406",
      "alt": "This image is the cover for the book Heydrich, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heydrich, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Reinhard Heydrich along with Heinrich Himmler, whose deputy he was, will always be regarded as one of the most ruthless of the Nazi elite. Even Hitler described him as ‘a man with an iron heart’.  He established his fearsome reputation in the 1930s, as head of the Sicherheitsdienst (SD), the intelligence organization which neutralized opposition to the Nazi Party by murder and deportation. He organized Kristalnacht and played a leading role in the Holocaust, chairing the 1942 Wannsee Conference which formalized plans for the ‘Final Solution’. In addition, as head of the Einsatzgruppen murder squads in Eastern Europe he was responsible for countless murders.  Appointed Deputy Reich-Protector of Bohemia and Moravia, he died of wounds inflicted by British trained SOE operatives in Prague in May 1942. The reprisals that followed his assassination were extreme by even the terrible standards of Nazi ruthlessness.  Heydrich’s shocking and leading role in the Nazi regime is graphically portrayed in this Images of War book.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ian Baxter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ian Baxter is a military historian who specialises in German twentieth-century military history. He has written more than fifty books. He has also reviewed numerous military studies for publication, supplied thousands of photographs and important documents to various publishers and film production companies worldwide, and lectures to various schools, colleges and universities throughout the United Kingdom and Southern Ireland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0